import {
  GET_ALL_KNOWLEDGE_BASE,
  GET_KNOWLEDGE_BASE_BY_ID,
  CREATE_KNOWLEDGE_BASE,
  UPDATE_KNOWLEDGE_BASE,
  DELETE_KNOWLEDGE_BASE,
  GET_ALL_KB_CATEGORIES,
  GET_KB_CATEGORY_BY_ID,
  CREATE_KB_CATEGORY,
  UPDATE_KB_CATEGORY,
  DELETE_KB_CATEGORY,
  GET_ALL_KB_ARTICLES,
  GET_KB_ARTICLE_BY_ID,
  CREATE_KB_ARTICLE,
  UPDATE_KB_ARTICLE,
  DELETE_KB_ARTICLE,
  UPLOAD_KB_ARTICLE_IMAGE,
  DELETE_KB_ARTICLE_IMAGE,
   UPLOAD_KB_IMAGE,
  DELETE_KB_IMAGE,
  UPLOAD_KB_CATEGORY_IMAGE,
  DELETE_KB_CATEGORY_IMAGE,
} from "../actions/types";

// ✅ Pattern same as setuphrstaffbasicinformationReducer.js / Agent Reducer

const initialState = {
  // Knowledge Base
  kbList: [],
  selectedKb: null,
  kbSaveStatus: null,
  kbUpdateStatus: null,
  kbDeleteStatus: null,

  // Category
  kbCategoryList: [],
  selectedKbCategory: null,
  kbCategorySaveStatus: null,
  kbCategoryUpdateStatus: null,
  kbCategoryDeleteStatus: null,

  // Article
  kbArticleList: [],
  selectedKbArticle: null,
  kbArticleSaveStatus: null,
  kbArticleUpdateStatus: null,
  kbArticleDeleteStatus: null,
  kbImageUploadStatus: null,
  kbImageDeleteStatus: null,

   kbImageData: null,
  kbCategoryImageData: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    // ──────────────── KNOWLEDGE BASE ────────────────
    case GET_ALL_KNOWLEDGE_BASE:
      return {
        ...state,
        kbList: action.payload.data,
      };
    case GET_KNOWLEDGE_BASE_BY_ID:
      return {
        ...state,
        selectedKb: action.payload.data,
      };
    case CREATE_KNOWLEDGE_BASE:
      return {
        ...state,
        kbSaveStatus: action.payload.success,
      };
    case UPDATE_KNOWLEDGE_BASE:
      return {
        ...state,
        kbUpdateStatus: action.payload.success,
      };
    case DELETE_KNOWLEDGE_BASE:
      return {
        ...state,
        kbDeleteStatus: action.payload.success,
      };

    // ──────────────── CATEGORY ────────────────
    case GET_ALL_KB_CATEGORIES:
      return {
        ...state,
        kbCategoryList: action.payload.data,
      };
    case GET_KB_CATEGORY_BY_ID:
      return {
        ...state,
        selectedKbCategory: action.payload.data,
      };
    case CREATE_KB_CATEGORY:
      return {
        ...state,
        kbCategorySaveStatus: action.payload.success,
      };
    case UPDATE_KB_CATEGORY:
      return {
        ...state,
        kbCategoryUpdateStatus: action.payload.success,
      };
    case DELETE_KB_CATEGORY:
      return {
        ...state,
        kbCategoryDeleteStatus: action.payload.success,
      };

    // ──────────────── ARTICLE ────────────────
    case GET_ALL_KB_ARTICLES:
      return {
        ...state,
        kbArticleList: action.payload.data,
      };
    case GET_KB_ARTICLE_BY_ID:
      return {
        ...state,
        selectedKbArticle: action.payload.data,
      };
    case CREATE_KB_ARTICLE:
      return {
        ...state,
        kbArticleSaveStatus: action.payload.success,
      };
    case UPDATE_KB_ARTICLE:
      return {
        ...state,
        kbArticleUpdateStatus: action.payload.success,
      };
    case DELETE_KB_ARTICLE:
      return {
        ...state,
        kbArticleDeleteStatus: action.payload.success,
      };
    case UPLOAD_KB_ARTICLE_IMAGE:
      return {
        ...state,
        kbImageUploadStatus: action.payload.success,
      };
    case DELETE_KB_ARTICLE_IMAGE:
      return {
        ...state,
        kbImageDeleteStatus: action.payload.success,
      };
// Inside switch:
case UPLOAD_KB_IMAGE:
case DELETE_KB_IMAGE:
  return { ...state, kbImageData: action.payload };

case UPLOAD_KB_CATEGORY_IMAGE:
case DELETE_KB_CATEGORY_IMAGE:
  return { ...state, kbCategoryImageData: action.payload };
    default:
      return state;
  }
}